import { ConnectorInfo } from '@blaze-shared/api-contracts-domain';
import { BaseSchema } from '@blaze-shared/schema-domain';
import { ComputeWorkflowNode } from '@blaze-shared/workflow-domain';

import { FORMULA_SOURCE_ID, NAME_SOURCE_ID, VALUE_SOURCE_ID } from '../../errors';
import {
  getColumnReferencesFromString,
  getNamedInputReferencesFromString,
  getParamReferencesFromString,
  getTagReferencesFromString,
} from '../../references/get-references-from-string';
import {
  WorkflowNodeColumnReference,
  WorkflowNodeNamedInputReference,
  WorkflowNodeParamReference,
  WorkflowNodeTagReference,
} from '../../references/references.models';
import { BaseWorkflowNode, WorkflowNode } from '../../registry/node.registry';

@WorkflowNode('Compute')
export class ComputeNode extends BaseWorkflowNode<ComputeWorkflowNode> {
  static readonly NAME_SOURCE_ID = NAME_SOURCE_ID;
  static readonly VALUE_SOURCE_ID = VALUE_SOURCE_ID;
  static readonly FORMULA_SOURCE_ID = FORMULA_SOURCE_ID;

  getColumnReferences(schemas: Map<string | symbol, BaseSchema>): WorkflowNodeColumnReference[] {
    return [
      ...getColumnReferencesFromString(this.node.value, schemas, ComputeNode.VALUE_SOURCE_ID),
      ...getColumnReferencesFromString(this.node.name, schemas, ComputeNode.NAME_SOURCE_ID),
      ...getColumnReferencesFromString(this.node.formula, schemas, ComputeNode.FORMULA_SOURCE_ID),
    ];
  }

  getTagReferences(schemas: Map<string | symbol, BaseSchema>): WorkflowNodeTagReference[] {
    return [
      ...getTagReferencesFromString(this.node.value, schemas, ComputeNode.VALUE_SOURCE_ID),
      ...getTagReferencesFromString(this.node.name, schemas, ComputeNode.NAME_SOURCE_ID),
      ...getTagReferencesFromString(this.node.formula, schemas, ComputeNode.FORMULA_SOURCE_ID),
    ];
  }

  getParamReferences(
    schemas: Map<string | symbol, BaseSchema>,
    connectors: ConnectorInfo[],
  ): WorkflowNodeParamReference[] {
    return [
      ...getParamReferencesFromString(
        this.node.value,
        schemas,
        connectors,
        ComputeNode.VALUE_SOURCE_ID,
      ),
      ...getParamReferencesFromString(
        this.node.name,
        schemas,
        connectors,
        ComputeNode.NAME_SOURCE_ID,
      ),
      ...getParamReferencesFromString(
        this.node.formula,
        schemas,
        connectors,
        ComputeNode.FORMULA_SOURCE_ID,
      ),
    ];
  }

  getNamedInputReferences(
    schemas: Map<string | symbol, BaseSchema>,
  ): WorkflowNodeNamedInputReference[] {
    return [
      ...getNamedInputReferencesFromString(this.node.value, schemas, ComputeNode.VALUE_SOURCE_ID),
      ...getNamedInputReferencesFromString(this.node.name, schemas, ComputeNode.NAME_SOURCE_ID),
      ...getNamedInputReferencesFromString(
        this.node.formula,
        schemas,
        ComputeNode.FORMULA_SOURCE_ID,
      ),
    ];
  }
}
